<template>
  <div class="parent-scanner">
    <CameraCodeScanner
        class="scanner-stream"
        @load="onLoad"
        @scan="onDecode"
    ></CameraCodeScanner>
  </div>
</template>

<script>
import { CameraCodeScanner } from "vue-barcode-qrcode-scanner";

export default {
  name: "Qrcode",
  components: {
    CameraCodeScanner
  },
  data() {
    return {
      ready: false
    }
  },
  methods:{
    onDecode (val) {
      this.$emit('onDetect', val)
    },
    onLoad ({controls, scannerElement, browserMultiFormatReader}) {
      // console.log(val)
    },
  }
}
</script>

<style scoped lang="scss">
.qr-stream  {
  position: fixed !important;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9999;
}

.camera-scope {
  position: fixed;
  top: calc(50% - 125px);
  left: calc(50% - 125px);
  width: 250px;
  height: 250px;
  z-index: 9999;

  div {
    position: absolute;
    width: 50px;
    height: 50px;
    border: solid 3px #fff;
  }
  div:nth-child(1) {
    top: 0;
    left: 0;
    border-right: none;
    border-bottom: none;
  }
  div:nth-child(2) {
    top: 0;
    right: 0;
    border-left: none;
    border-bottom: none;
  }
  div:nth-child(3) {
    bottom: 0;
    left: 0;
    border-top: none;
    border-right: none;
  }
  div:nth-child(4) {
    bottom: 0;
    right: 0;
    border-top: none;
    border-left: none;
  }
}

.scanner-stream {
  height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  //position: fixed !important;
  //top: var(--header-height);
  //bottom: calc(var(--footer-height) - (var(--scanner-btn-size) / 2));
  //left: 0;
  //right: 0;
  //z-index: 9999;
}

.parent-scanner {
  margin: -12px;
  position: relative;
  overflow: hidden;
  height: calc(100vh - var(--header-height) - (var(--footer-height) - (var(--scanner-btn-size) / 2)));
}
</style>